import { render } from "./InventoryListDropdown.vue?vue&type=template&id=8236c6a6&scoped=true"
import script from "./InventoryListDropdown.vue?vue&type=script&lang=js"
export * from "./InventoryListDropdown.vue?vue&type=script&lang=js"

import "./InventoryListDropdown.vue?vue&type=style&index=0&id=8236c6a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8236c6a6"]])

export default __exports__